import React from 'react';
import {
  FormControl,
  FormLabel,
  Text,
  Box,
  Input,
  FormErrorMessage,
} from '@chakra-ui/react';

const NumericInput = React.forwardRef(
  ({ error, info, prefix, suffix, onChange, placeholder, value, required = false, label, ...props }, ref) => {
    const format = (val) => {
      if (val == null) return '';
      val = val.toString().replace(/\D/g, ''); // remove non-digits
      return val.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // add commas
    };

    const parse = (val) => val.replace(/,/g, '');

    return (
      <FormControl isInvalid={error}>
        {label && (
          <FormLabel
            fontSize="12px"
            color="gray.400"
            fontWeight="600"
            textTransform="uppercase"
          >
            {label}{' '}
            {required && (
              <Text as={'span'} fontSize="xs" color="red">
                *
              </Text>
            )}
          </FormLabel>
        )}

        <Box position="relative">
          {prefix && (
            <Text
              position="absolute"
              fontSize="sm"
              color="gray.500"
              left="10px"
              top="50%"
              transform="translateY(-50%)"
            >
              {prefix}
            </Text>
          )}
          {suffix && (
            <Text
              position="absolute"
              fontSize="sm"
              color="gray.500"
              right="10px"
              top="50%"
              transform="translateY(-50%)"
            >
              {suffix}
            </Text>
          )}

          <Input
            ref={ref}
            type="text"
            inputMode="numeric"
            value={format(value)}
            onChange={(e) => onChange(parse(e.target.value))}
            placeholder={placeholder || '0'}
            pl={prefix ? '30px' : '12px'}
            pr={suffix ? '30px' : '12px'}
            {...props}
          />
        </Box>

        {info && (
          <Text fontSize="xs" color="gray.500">
            {info}
          </Text>
        )}
        <FormErrorMessage>{error}</FormErrorMessage>
      </FormControl>
    );
  }
);

export { NumericInput };
